/** Boundary of a one-dimensional interval. */
export const Boundary = {
  START: 'start',
  // tslint:disable-next-line:object-literal-sort-keys
  END: 'end'
};
